<template>
  <v-dialog
    v-model="open"
    :max-width="maxWidth"
    scollable
    :scrim="true"
    @keydown.stop.esc="open = false"
    content-class="dialog-top-right"
  >
    <template #activator="{ props }">
      <slot name="activator" :openDialog="openDialog" :props="props">
        <v-btn
          size="21"
          variant="plain"
          icon="mds:help"
          :class="{
            'ml-2' : includeMargin,
            'mr-4' : includeMargin,
            'ml-0' : !includeMargin,
            'mr-0' : !includeMargin
          }"
          class="d-inline-flex"
          @click="openDialog"
        />
      </slot>
    </template>

    <v-card class="mr-4 mt-4">
      <v-toolbar>
        <v-toolbar-title style="flex-basis: 100%;">
          <v-icon color="white">mdi-help-circle-outline</v-icon>&nbsp;&nbsp;<b class="text-white">{{ title }}</b>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          variant="plain"
          icon="mds:close"
          class="mr-4"
          @click="open = false"
          color="white"
        />
      </v-toolbar>

      <v-card-text class="mt-1 mb-4" @click="onContentClick">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { handleLinkActionClick } from '@/utils/linkActions'

const router = useRouter()

defineProps({
  title: {
    type: String,
    default: 'Help'
  },
  maxWidth: {
    type: String,
    default: '600px'
  },
  includeMargin: {
    type: Boolean,
    default: true
  }
})

const open = ref(false)

const openDialog = () => {
  nextTick(() => {
    open.value = true
  })
}

const onContentClick = (event) => {
  if (handleLinkActionClick(event, router)) {
    open.value = false
  }
}
</script>

<style scoped>
:deep(.v-toolbar__content) {
  background-color: var(--text-light);
}
</style>

<style>
[data-theme="dark"] .v-overlay__content > .v-card > .v-toolbar > .v-toolbar__content {
  background-color: var(--light-5) !important;
}
</style>
